package com.qrkontaq.utils

import kotlinx.browser.window

/**
 * The visitor's primary system language, normalized: "en-US" -> "en",
 * and Ukraine's non-standard "ua" -> "uk".
 */
fun systemLanguageCode(): String {
    val raw = window.navigator.language.lowercase().substringBefore('-')
    return if (raw == "ua") "uk" else raw
}

/**
 * Resolves a language code: a previously [saved] choice wins, otherwise the
 * visitor's system language when it is among [supported], otherwise [fallback].
 */
fun resolveLanguage(
    saved: String?,
    supported: List<String>,
    fallback: String,
): String {
    saved?.takeIf { it in supported }?.let { return it }
    systemLanguageCode().takeIf { it in supported }?.let { return it }
    return fallback
}
